exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".customer-search-modal{cursor:default}.customer-search-modal .warranty-ckc-iframe{border:2px solid #000;height:97%;margin:auto;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/shared/components/customer-search-2/customer-search-2-modal.scss
// module id = 5147
// module chunks = 0